import * as React from 'react'
import { FC, useCallback } from 'react'

import { permissionDenied } from '@user/store/authorization/permissions'
import { ButtonWithTooltip } from '@sales-center/components'

import CardActions from '@mui/material/CardActions'
import { SxProps } from '@mui/material/styles'

const styles = {
  callToActionBtn: {
    color: '#1265a9',
    fontSize: '14px',
    marginLeft: 'auto',
  },
}

interface Props {
  callToActionFunction: () => void
  callToActionText: string
  callToActionAllowed: boolean
  children?: JSX.Element
  sx?: SxProps
  secondaryCallToActionFunction?: () => void
  secondaryCallToActionText?: string
  secondaryCallToActionAllowed?: boolean
  testIdPrefix?: string
}

export const WidgetFooter: FC<Props> = (props) => {
  const {
    callToActionFunction,
    callToActionText,
    callToActionAllowed,
    sx,
    secondaryCallToActionFunction,
    secondaryCallToActionText,
    secondaryCallToActionAllowed,
    testIdPrefix = 'widget-footer',
  } = props

  const handleCallToActionFunction = useCallback(() => {
    callToActionFunction()
  }, [callToActionFunction])

  const handleSecondaryCallToActionFunction = useCallback(() => {
    if (secondaryCallToActionFunction) {
      secondaryCallToActionFunction()
    }
  }, [secondaryCallToActionFunction])

  return (
    <CardActions sx={sx}>
      {secondaryCallToActionText && secondaryCallToActionFunction && (
        <ButtonWithTooltip
          dataTestId={`${testIdPrefix}-secondary`}
          sx={styles.callToActionBtn}
          onClick={handleSecondaryCallToActionFunction}
          spanSx={styles.callToActionBtn}
          tooltipTitle={permissionDenied}
          showTooltip={!secondaryCallToActionAllowed}
          disabled={!secondaryCallToActionAllowed}
        >
          {secondaryCallToActionText}
        </ButtonWithTooltip>
      )}
      <ButtonWithTooltip
        dataTestId={`${testIdPrefix}-primary`}
        sx={styles.callToActionBtn}
        onClick={handleCallToActionFunction}
        spanSx={styles.callToActionBtn}
        tooltipTitle={permissionDenied}
        showTooltip={!callToActionAllowed}
        disabled={!callToActionAllowed}
      >
        {callToActionText}
      </ButtonWithTooltip>
    </CardActions>
  )
}

WidgetFooter.displayName = 'WidgetFooter'
